import { action, Action } from 'easy-peasy';

export interface IInitModel {
    /** （图片编辑）是否载已入舞台 */
    finishInit: boolean;
    setFinishInit: Action<IInitModel, boolean>;
    /** 是否调用过获取用户信息接口 */
    hasGetInfo: boolean;
    setHasGetInfo: Action<IInitModel, boolean>;
}

export const initModel: IInitModel = {
    finishInit: false,
    setFinishInit: action((state, finishInit) => {
        state.finishInit = finishInit;
    }),
    hasGetInfo: false,
    setHasGetInfo: action((state, payload) => {
        state.hasGetInfo = payload;
    }),
};
